import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navConfigPropTypes } from 'constants/propTypes';
import NavLink from './NavLink';

function NavDropdownMenu(props) {
  const {
    config: { children },
    hideMobileNavOpen,
    shouldRender,
  } = props;

  const [shouldRenderResults, setShouldRenderResults] = useState({});

  useEffect(() => {
    let cancelled = false;
    const fetchShouldRenderResults = async () => {
      const results = {};
      await Promise.all(
        children.map(async config => {
          results[config.message.id] = await shouldRender(config);
        })
      );
      if (!cancelled) setShouldRenderResults(results);
    };

    fetchShouldRenderResults();

    return () => {
      cancelled = true;
    };
  }, [children]);

  return (
    <div className="nav__dropdown-menu">
      {children.map(config => {
        const { message } = config;
        if (!shouldRenderResults[message.id]) return null;

        return (
          <NavLink
            key={message.id}
            {...props}
            className="nav__dropdown-menu-item"
            showText
            config={config}
            handleClick={() => hideMobileNavOpen()}
          />
        );
      })}
    </div>
  );
}

NavDropdownMenu.propTypes = {
  config: navConfigPropTypes,
  hideMobileNavOpen: PropTypes.func,
  shouldRender: PropTypes.func,
};

export default NavDropdownMenu;
